import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Dropdown } from 'react-bootstrap';
import { List, Map } from 'immutable';
import { injectIntl } from 'react-intl';
import appConfig from '../../appConfig';
import piction from '../../utils/piction';
import {
  deselectAll,
  selectPage,
  selectSearch,
  setLastSelectedUMOID,
} from '../../actions/umoGallery';
import {
  showWorkspaceEmailDialog,
  showUMOModifyDialog,
} from '../../actions/mainUI';
import { removeFromWorkspace, relateUMOs } from '../../actions/umo';
import { SearchParams } from '../../utils/searchUtils';
import {
  createExcelExportURL,
  createPPTExportURL,
  createPDFExportURL,
  savetoDropbox,
  moveUmoHandler,
} from '../../utils/umoUtils';
import {
  getLabelFromAppConfig,
  showBasket,
  showPhotoBasket,
  showWorkspaceLoader,
  downloadExportFile,
  downloadFile,
} from '../../utils/uiUtils';
import { validateSessionConnection } from '../../actions/session';
import { addIntlError, addIntlInfo } from '../../actions/messageDialog';
import {
  deselectAll as deselectAllWS,
  selectAll,
} from '../../actions/workspacePreview';
import { defaultWorkspaceMenu } from '../../constants/umoGallery';
import {
  UMO_MODIFY_TYPE_RESIZE,
  UMO_MODIFY_TYPE_ZIP_DOWNLOAD,
  UMO_MODIFY_TYPE_PDF_DOWNLOAD,
} from '../../constants/umoModifications';
import ActionIcon from '../Icons/ActionDefault';
import DeleteIcon from '../Icons/DeleteDefault';
import ExportZipIcon from '../Icons/ExportAllToZipDefault';
import PhotoIcon from '../Icons/PhotographyRequestDefault';
import RelateAllItemIcon from '../Icons/RelateAllItemsDefault';
import ResizeIcon from '../Icons/ResizeAllDefault';
import SelectionIcon from '../Icons/SelectionDefault';
import ShareIcon from '../Icons/ShareDefault';
import SlideIcon from '../Icons/SlideshowDefault';
import ExcelIcon from '../Icons/FileExcelDefault';
import DowloadIcon from '../Icons/Dowload';
import AddIcon from '../Icons/Add';
import ExportPDFIcon from '../Icons/FilePdfDefault';
import EmailIcon from '../Icons/EmailAllDefaul';
import { showBulkMetaEditAsMain } from '../../actions/mainUI';
import { isValidForBulkEdit } from '../BulkMetaEdit/helpers';
const mapStateToProps = (state) => ({
  session: state.session,
  umoGallery: state.umoGallery,
});

const mapDispatchToProps = (dispatch) => ({
  validateSession: (surl) => dispatch(validateSessionConnection(surl)),
  showBulkEditView: () => dispatch(showBulkMetaEditAsMain()),
  addInprogressMessage: () => dispatch(addIntlInfo('umoModifyDialog.inProgressMessage')),
});

function OptionsMenu({
  dispatch,
  searchParams,
  selectedWorkspaceData = { id: null },
  selectedUMOIDs,
  isSelectAll,
  intl,
  session,
  validateSession,
  isUMOGalleryWorkspace,
  isPinnedWorkspace = false,
  className,
  id,
  size,
  disabled = false,
  umoList,
  umoGallery,
  showBulkEditView,
  addInprogressMessage,
}) {
  const shouldWorkspaceOptions =
    isUMOGalleryWorkspace ||
    searchParams.getSearchType() === SearchParams.searchTypes.WORKSPACE;
  const deselectUMOs = () => isPinnedWorkspace ? dispatch(deselectAllWS()) : dispatch(deselectAll());
  const onOptionsSelect = (selectedOption) => {
    if (umoList.size === 0)
      dispatch(addIntlError('searchResults.options.actions.noUMOsSelected'));
    else {
      validateSession(session.get('surl')).then((r) => {
        if (r.isValid) {
          switch (selectedOption) {
            case 'bulkEdit':
              showBulkEditView();
              break;
            case 'selectPage':
              dispatch(selectPage());
              break;
            case 'selectSearch':
              if (isPinnedWorkspace) {
                dispatch(selectAll());
              } else {
                dispatch(selectSearch());
              }
              break;
            case 'deselectAll':
              dispatch(setLastSelectedUMOID(null));
              deselectUMOs();
              break;
            case 'addToWorkspace':
              if (selectedWorkspaceData.id) {
                const origin = {
                  id: 1,
                  isWorkspace: false,
                };
                const target = {
                  id: selectedWorkspaceData.id,
                  isWorkspace: true,
                };
                moveUmoHandler(
                  origin,
                  target,
                  selectedUMOIDs,
                  dispatch,
                  isSelectAll ? searchParams : null
                );
              }
              break;
            case 'removeFromWorkspace': {
              const umoDataList = selectedUMOIDs.map((umoID) => ({
                id: umoID,
              }));
              dispatch(
                removeFromWorkspace(
                  selectedWorkspaceData.id,
                  umoDataList.toJS(),
                  isSelectAll ? searchParams : null
                )
              );
              break;
            }
            case 'exportToExcel': {
              downloadExportFile(
                createExcelExportURL(
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  false,
                  isSelectAll || selectedUMOIDs.size < 1 ? searchParams : null
                ),
                dispatch
              );
              deselectUMOs();
              addInprogressMessage();
              break;
            }
            case 'exportAllToExcel': {
              downloadExportFile(
                createExcelExportURL(
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  true,
                  isSelectAll || selectedUMOIDs.size < 1 ? searchParams : null
                ), dispatch
              );
              deselectUMOs();
              addInprogressMessage();
              break;
            }
            case 'exportToPPT': {
              downloadExportFile(
                createPPTExportURL(
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  isSelectAll || selectedUMOIDs.size < 1 ? searchParams : null
                ), dispatch
              );
              deselectUMOs();
              addInprogressMessage();
              break;
            }
            case 'exportToZIP': {
              dispatch(
                showUMOModifyDialog(
                  {
                    modType: UMO_MODIFY_TYPE_ZIP_DOWNLOAD,
                    isPinnedWorkspace,
                  },
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  searchParams,
                  { id: selectedWorkspaceData.id }
                )
              );
              break;
            }
            case 'exportToPDF': {
              if (appConfig.advanced?.pdfAllowOnePerPage) {
                downloadFile(
                  createPDFExportURL(
                    selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                    selectedWorkspaceData.id,
                    1, // Always use 1 item per page when pdfAllowOnePerPage is true
                    isSelectAll
                  ),
                  false
                );
                addInprogressMessage();
                deselectUMOs();
              } else {
                dispatch(
                  showUMOModifyDialog(
                    {
                      modType: UMO_MODIFY_TYPE_PDF_DOWNLOAD,
                      isPinnedWorkspace,
                    },
                    selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                    searchParams,
                    { id: selectedWorkspaceData.id }
                  )
                );
              }
              break;
            }
            case 'batchDownload': {
              dispatch(
                showUMOModifyDialog(
                  {
                    modType: UMO_MODIFY_TYPE_ZIP_DOWNLOAD,
                    isBatchDownload: true,
                    isPinnedWorkspace,
                  },
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  searchParams,
                  { id: selectedWorkspaceData.id }
                )
              );
              break;
            }
            case 'saveToDropbox': {
              const newUMOIDList = [];
              if (isSelectAll || selectedUMOIDs.size < 1) {
                umoList.toJS().forEach((umoData) => {
                  if (
                    !selectedUMOIDs.find((umoID) => umoID === umoData.id[0])
                  ) {
                    newUMOIDList.push({
                      id: umoData.id[0],
                      umo: new PictionJS.UMO(umoData, {
                        hostURL: piction.hostURL,
                      }),
                    });
                  }
                });
              } else if (selectedUMOIDs.size > 0) {
                umoList.toJS().forEach((umoData) => {
                  if (selectedUMOIDs.find((umoID) => umoID === umoData.id[0])) {
                    newUMOIDList.push({
                      id: umoData.id[0],
                      umo: new PictionJS.UMO(umoData, {
                        hostURL: piction.hostURL,
                      }),
                    });
                  }
                });
              }
              if (newUMOIDList.length > 0)
                savetoDropbox(newUMOIDList, dispatch);
              else
                dispatch(addIntlError('searchResults.options.actions.noUMOsSelected'));
              break;
            }
            case 'showBasket': {
              showBasket(
                dispatch,
                selectedWorkspaceData.id,
                selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                isSelectAll || selectedUMOIDs.size < 1,
                intl.locale
              );
              break;
            }
            case 'showPhotoBasket': {
              showPhotoBasket(
                dispatch,
                selectedWorkspaceData.id,
                selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                isSelectAll || selectedUMOIDs.size < 1,
                intl.locale
              );
              break;
            }
            case 'email':
              dispatch(
                showWorkspaceEmailDialog({
                  id: selectedWorkspaceData.id,
                  isPortal: false,
                })
              );
              break;
            case 'relateUMOs': {
              dispatch(relateUMOs(selectedWorkspaceData.id));
              break;
            }
            case 'shareAsPortal': {
              dispatch(
                showWorkspaceEmailDialog({
                  id: selectedWorkspaceData.id,
                  isPortal: true,
                })
              );
              break;
            }
            case 'shareExternalPortal': {
              dispatch(
                showWorkspaceEmailDialog({
                  id: selectedWorkspaceData.id,
                  isPortal: true,
                  isDMZPortal: true,
                })
              );
              break;
            }
            case 'resizeAll': {
              dispatch(
                showUMOModifyDialog(
                  {
                    modType: UMO_MODIFY_TYPE_RESIZE,
                    isPinnedWorkspace,
                  },
                  selectedUMOIDs.size > 0 ? selectedUMOIDs.toJS() : null,
                  searchParams,
                  { id: selectedWorkspaceData.id }
                )
              );
              break;
            }
            case 'showWorkspaceLoader': {
              showWorkspaceLoader(dispatch, selectedWorkspaceData.id);
              break;
            }
            default:
              break;
          }
        }
        return null;
      });
    }
  };

  const optionList =
    appConfig.menuOptions &&
    appConfig.menuOptions.workspaceMenu &&
    appConfig.menuOptions.workspaceMenu.length > 0
      ? appConfig.menuOptions.workspaceMenu
      : defaultWorkspaceMenu;
  // show options according workspace/category
  const catOption = !selectedWorkspaceData.id || appConfig.removeWorkspaces ? [] : ['addToWorkspace'];
  const options = !shouldWorkspaceOptions
    ? catOption
    : ['removeFromWorkspace', ...optionList];
  const menuOptions = [];
  options.forEach((value) => {
    switch (value) {
      case 'exportXLS':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="exportToExcel">
            <ExcelIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.exportTagsToExcel' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'exportAllToXLS':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="exportAllToExcel"
          >
            <ExcelIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.exportAllToExcel' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'exportPPT':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="exportToPPT">
            <SlideIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.exportToPPT' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'exportZIP':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="exportToZIP">
            <ExportZipIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.exportToZip' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'exportPDF':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="exportToPDF">
            <ExportPDFIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.exportToPDF' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'batchDownload':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="batchDownload">
            <DowloadIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.batchDownload' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'saveToDropbox':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="saveToDropbox">
            <DowloadIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.saveToDropbox' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'usageBasket':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="showBasket">
            <SelectionIcon style={{ marginRight: 5 }} />
            {getLabelFromAppConfig(appConfig.templates.basket, intl.locale)}
          </Dropdown.Item>
        );
        break;
      case 'photoBasket':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="showPhotoBasket"
          >
            <PhotoIcon
              style={{ marginRight: 5 }}
              width={20}
              height={20}
              fill="#545659"
            />
            {getLabelFromAppConfig(
              appConfig.templates.photoBasket,
              intl.locale
            )}
          </Dropdown.Item>
        );
        break;
      case 'email':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="email">
            <EmailIcon style={{ marginRight: 5 }} />
            {intl.formatMessage({
              id: 'searchResults.options.actions.emailAll',
            })}
          </Dropdown.Item>
        );
        break;
      case 'relateUMOs':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="relateUMOs">
            <RelateAllItemIcon style={{ marginRight: 5 }} />
            {intl.formatMessage({
              id: 'searchResults.options.actions.relateAllInWorkspace',
            })}
          </Dropdown.Item>
        );
        break;
      case 'shareAsPortal':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="shareAsPortal">
            <ShareIcon
              fill="#545659"
              style={{ marginRight: 5 }}
              width={20}
              height={20}
            />
            {intl.formatMessage({
              id: 'searchResults.options.actions.shareAsPortal',
            })}
          </Dropdown.Item>
        );
        break;
      case 'shareExternalPortal':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="shareExternalPortal"
          >
            <ShareIcon
              fill="#545659"
              style={{ marginRight: 5 }}
              width={20}
              height={20}
            />
            {intl.formatMessage({
              id: 'searchResults.options.actions.shareExternalPortal',
            })}
          </Dropdown.Item>
        );
        break;
      case 'resizeAll':
        menuOptions.push(
          <Dropdown.Item key={menuOptions.length + 1} eventKey="resizeAll">
            <ResizeIcon style={{ marginRight: 5 }} />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.resize' },
              { selectCount: selectedUMOIDs.size }
            )}
          </Dropdown.Item>
        );
        break;
      case 'removeFromWorkspace':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="removeFromWorkspace"
          >
            <DeleteIcon style={{ marginRight: 5 }} />
            {intl.formatMessage({
              id: 'searchResults.options.actions.removeSelectedFromWorkspace',
            })}
          </Dropdown.Item>
        );
        break;
      case 'addToWorkspace':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="addToWorkspace"
            disabled={
              !selectedWorkspaceData.id ||
              (!isSelectAll && selectedUMOIDs.size < 1)
            }
          >
            <AddIcon
              fill="#545659"
              style={{ marginRight: 5 }}
              width={20}
              height={20}
            />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.addToWorkspace' },
              {
                workspaceName: selectedWorkspaceData.id
                  ? `"${selectedWorkspaceData.name}"`
                  : intl.formatMessage({
                      id: 'searchResults.options.actions.addToWorkspace.default',
                    }),
              }
            )}
          </Dropdown.Item>
        );
        break;
      case 'workspaceLoader':
        menuOptions.push(
          <Dropdown.Item
            key={menuOptions.length + 1}
            eventKey="showWorkspaceLoader"
            disabled={
              !selectedWorkspaceData.id ||
              (!isSelectAll && selectedUMOIDs.size < 1)
            }
          >
            <AddIcon
              fill="#545659"
              style={{ marginRight: 5 }}
              width={20}
              height={20}
            />
            {intl.formatMessage(
              { id: 'searchResults.options.actions.addToWorkspace' },
              {
                workspaceName: selectedWorkspaceData.id
                  ? `"${selectedWorkspaceData.name}"`
                  : intl.formatMessage({
                      id: 'searchResults.options.actions.addToWorkspace.default',
                    }),
              }
            )}
          </Dropdown.Item>
        );
        break;
      default:
        break;
    }
  });

  let customMenuItems;
  if (
    shouldWorkspaceOptions &&
    appConfig.menuOptions.customWorkspaceMenu &&
    _.isArray(appConfig.menuOptions.customWorkspaceMenu)
  ) {
    let curVal;
    let mtVal;
    let umoIDs = umoList
      .toJS()
      .map((umoData) => `${umoData.id[0]}`)
      .join(',');
    // get the relevant umos from the umoList
    customMenuItems = _.map(
      appConfig.menuOptions.customWorkspaceMenu,
      (item, index) => {
        if (item.metatag) {
          curVal = _.split(item.metatag, '.');
          umoIDs = _.map(umoList.toJS(), (umoData) => {
            mtVal =
              umoData.m && umoData.m[0].mv
                ? umoData.m[0].mv.find(
                    (mt) => mt.$.c === curVal[1] && mt.$.i === curVal[0]
                  )
                : null;
            return mtVal ? mtVal._ : null;
          });
          umoIDs = umoIDs.filter((n) => n).join(',');
        }
        return (
          <li role="presentation" key={'custom-menu-item-' + index}>
            <a
              className="dropdown-item"
              href={item.link + umoIDs}
              target="_blank"
            >
              <ResizeIcon style={{ marginRight: 5 }} />
              {item.label}
            </a>
          </li>
        );
      }
    );
  }
  return (
    <Dropdown onSelect={onOptionsSelect}>
      <Dropdown.Toggle
        variant="default"
        size={size}
        id={id}
        className={className}
        disabled={disabled}
      >
        {intl.formatMessage({ id: 'searchResults.options' })}
        {/*<span className="caret" />*/}
      </Dropdown.Toggle>
      <Dropdown.Menu className="workspace-preview__options-menu">
        <Dropdown.Header>
          <SelectionIcon style={{ marginRight: 5 }} />
          {intl.formatMessage({ id: 'searchResults.options.selection' })}
        </Dropdown.Header>
        {!isPinnedWorkspace ? (
          <Dropdown.Item key={menuOptions.length + 1} eventKey="selectPage">
            {intl.formatMessage({
              id: 'searchResults.options.selection.selectPage',
            })}
          </Dropdown.Item>
        ) : null}
        <Dropdown.Item key={menuOptions.length + 2} eventKey="selectSearch">
          {isPinnedWorkspace
            ? intl.formatMessage({ id: 'workspacePreview.selection.selectAll' })
            : intl.formatMessage({
                id: 'searchResults.options.selection.selectSearch',
              })}
        </Dropdown.Item>
        <Dropdown.Item key={menuOptions.length + 3} eventKey="deselectAll">
          {intl.formatMessage({
            id: 'searchResults.options.selection.deselectAll',
          })}
        </Dropdown.Item>
        {(selectedUMOIDs.size > 0 || isSelectAll) &&
          isValidForBulkEdit(searchParams) && (
            <Dropdown.Item key={menuOptions.length + 4} eventKey="bulkEdit">
              {intl.formatMessage({
                id: 'searchResults.options.selection.bulkEdit',
              })}
            </Dropdown.Item>
          )}
        {menuOptions.length > 0 || customMenuItems ? (
          <Dropdown.Divider />
        ) : null}
        {menuOptions.length > 0 || customMenuItems ? (
          <Dropdown.Header>
            <ActionIcon style={{ marginRight: 5 }} />
            {intl.formatMessage({ id: 'searchResults.options.actions' })}
          </Dropdown.Header>
        ) : null}
        {menuOptions}
        {customMenuItems}
      </Dropdown.Menu>
    </Dropdown>
  );
}

OptionsMenu.propTypes = {
  dispatch: PropTypes.func,
  searchParams: PropTypes.instanceOf(SearchParams),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedUMOIDs: PropTypes.instanceOf(List),
  isSelectAll: PropTypes.bool,
  session: PropTypes.instanceOf(Map),
  validateSession: PropTypes.func,
  addInprogressMessage: PropTypes.func,
  isUMOGalleryWorkspace: PropTypes.bool,
  isPinnedWorkspace: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  umoList: PropTypes.instanceOf(List),
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(OptionsMenu)
);
